import { Pipe, PipeTransform } from '@angular/core';
import isEmpty from 'lodash/isEmpty';

type formatType = 'frontend' | 'frontend-ext' | 'backend';

const searchTerm: RegExp = /[\(,\),\-,\s]/g;
const replaceValue: string = '';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  public transform(phone: string, format: formatType = 'backend', prefix: string = '+1'): string {
    if (isEmpty(phone)) return phone;
    let phoneFormatted: string;
    if (format === 'backend') {
      phoneFormatted = phone.replace(searchTerm, replaceValue);
      return `${prefix}${phoneFormatted}`;
    } else if (format === 'frontend') {
      const phoneArray: string[] = phone.substr(1).split('');
      const digitAt = (index: number) => phoneArray[index] || '';
      const phoneMask: string[] = ['(', digitAt(1), digitAt(2), digitAt(3), ')', ' ', digitAt(4), digitAt(5), digitAt(6),
        '-', digitAt(7), digitAt(8), digitAt(9), digitAt(10)];
      return phoneMask.join('');
    } else if (format === 'frontend-ext') {
      const phoneNumberParts: string[] = phone.substr(1).split(',');
      const phoneNumberArray: string[] = isEmpty(phoneNumberParts[0]) ? [] : phoneNumberParts[0].split('');
      const areaCodeArray: string[] = isEmpty(phoneNumberParts[1]) ? [] : phoneNumberParts[1].split('');

      const numberAt = (index: number) => phoneNumberArray[index] || '';
      const areaCodeAt = (index: number) => areaCodeArray[index] || '';

      const areaCodeMask: string[] = areaCodeArray.length === 0 ? [] :
        [' ', 'ext.', ' ', areaCodeAt(0), areaCodeAt(1), areaCodeAt(2), areaCodeAt(3), areaCodeAt(4), areaCodeAt(5)];
      const phoneMask: string[] = ['(', numberAt(1), numberAt(2), numberAt(3), ')', ' ', numberAt(4), numberAt(5), numberAt(6),
        '-', numberAt(7), numberAt(8), numberAt(9), numberAt(10), ...areaCodeMask];
      return phoneMask.join('').trim();
    }

    return phone;
  }
}
